import { CourseStatus, CourseType, URLS } from "@/lib/constants";
import type { CourseThumbnailItem } from "@/types";
import { buildLessonUrl } from "@/utils/buildLessonUrl";

/**
 * Destination for a purchased-course card, mirroring the press handler on the
 * purchased-courses page:
 *   * redirect-type course with a canonical in-app home → that redirect_url;
 *   * not published in Josephine → the WordPress course page;
 *   * per-lesson (companion) grant → the granted lesson;
 *   * otherwise → the in-app course page.
 */
export function purchasedCourseHref(
  item: Pick<
    CourseThumbnailItem,
    "slug" | "status" | "lessonSlug" | "courseType" | "redirectUrl"
  >,
): string {
  if (item.status !== CourseStatus.Published) {
    if (item.courseType === CourseType.Redirect && item.redirectUrl) {
      return item.redirectUrl;
    }
    return URLS.course(item.slug);
  }
  if (item.lessonSlug) {
    return buildLessonUrl({ courseSlug: item.slug, lessonSlug: item.lessonSlug });
  }
  return `/courses/${item.slug}`;
}
